import { render, staticRenderFns } from "./ModeratorAcademicTimeAccountanceView.vue?vue&type=template&id=56729fcc"
import script from "./ModeratorAcademicTimeAccountanceView.vue?vue&type=script&lang=js"
export * from "./ModeratorAcademicTimeAccountanceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports